import { Button } from "@/components/ui/Button";
import { P } from "@/components/ui/Heading";
import SafeHtmlRenderer from "@/components/ui/SafeHtmlRenderer";
import { Link } from "@/i18n/routing";
import { ChevronRight } from "lucide-react";
import { ElementType } from "react";
interface ToolCardProps {
  title: string;
  description: string;
  link: string;
  cta: string;
  disabled: boolean;
  icon: ElementType;
}

export const ToolCard = ({
  cta,
  description,
  icon: Icon,
  link,
  title,
  disabled,
}: ToolCardProps) => {
  return (
    <div className="bg-white p-4 sm:p-6 rounded-lg border flex flex-col gap-6">
      <div className="flex gap-4 items-start">
        <Icon height="48px" width="48px" strokeWidth="2" />
        <div className="sm:space-y-1">
          <P className="text-base sm:text-lg font-semibold">{title}</P>
          <div className="text-sm">
            <SafeHtmlRenderer html={description} />
          </div>
        </div>
      </div>
      {disabled ? (
        <Button
          variant={"tertiary"}
          className="h-12 font-normal w-full cursor-not-allowed"
          size={"lg"}
          disabled={disabled}
        >
          Coming Soon
        </Button>
      ) : (
        <Link href={link}>
          <Button
            variant={"tertiary"}
            className="h-12 font-normal w-full"
            size={"lg"}
            disabled={disabled}
          >
            {cta}
            <ChevronRight className="!size-5" />
          </Button>
        </Link>
      )}
    </div>
  );
};
